import { track, logError } from '@tracking';

import { getCountry } from '@shared/selectors';
import getShop from '@core/reducers/shop/selectors/getShop';
import getCart from '@core/reducers/cart/selectors/getCart';
import getShopId from '@core/reducers/shop/selectors/getShopId';
import getShopName from '@core/reducers/shop/selectors/getShopName';

import getShopStatus from '@utils/tracking/getShopStatus';

import { getCartStatus } from '../utils';

const EVENT_NAME = 'checkout.clicked';

const trackCheckoutClicked = () => (dispatch, getState) => {
  try {
    const state = getState();
    const shop = getShop(state);
    const cart = getCart(state);
    const country = getCountry(state);

    const shopId = getShopId(state);
    const shopName = getShopName(state);
    const cartValue = cart.total;
    const cartStatus = getCartStatus(cart);
    const currencyCode = country.currencyIsoCode;
    const shopStatus = getShopStatus(shop);

    const payload = {
      shopId,
      shopName,
      shopStatus,
      currencyCode,
      cartStatus,
      cartValue,
    };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackCheckoutClicked;
